import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { appViewFetchUserSuccess } from '../appViewSlice';
import { RootState } from '../../../store';
import { routingOnRouteRequest } from '../routingSlice';
import { Routes } from 'src/routes';

type IN = ReturnType<typeof appViewFetchUserSuccess>;
type OUT = ReturnType<typeof routingOnRouteRequest>;

export const LoginViewOnLoginSuccessfulEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(appViewFetchUserSuccess.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [routingOnRouteRequest({ path: Routes.Root })];
    }),
  );
